import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from '@/i18n/hooks/useTranslation'
import { SuccessStep } from '../components/SuccessStep'

export function ChallengeSuccessPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  // Get data from navigation state or redirect to selection
  const { selectedChallenge, customTitle, createdChallenge } = location.state || {}
  
  // Redirect to selection if no data
  useEffect(() => {
    if (!location.state || !createdChallenge) {
      navigate('/challenges/new/selection')
    }
  }, [location.state, createdChallenge, navigate])

  const handleComplete = () => {
    // Navigate to home page where users can see all their challenges
    navigate('/')
  }

  const handleCreateAnother = () => {
    // Navigate back to selection step to start fresh
    navigate('/challenges/new/selection')
  }

  // Show loading if no state data
  if (!location.state || !createdChallenge) {
    return (
      <div className="min-h-screen bg-bg flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-md"></div>
          <p className="text-text">{t('common.loading')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-bg">
      <div className="max-w-2xl mx-auto px-lg py-2xl">
        <div className="rounded-xl">
          {/* Progress Indicator */}
          <div className="mb-2xl">
            <div className="flex items-center justify-center space-x-md">
              <button
                onClick={() => navigate('/challenges/new/selection')}
                className="flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium bg-primary text-white dark:text-black cursor-pointer hover:scale-110 hover:shadow-lg transition-all duration-200"
              >
                1
              </button>
              <div className="w-16 h-1 bg-primary" />
              <button
                onClick={() => navigate('/challenges/new/frequency', { state: location.state })}
                className="flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium bg-primary text-white dark:text-black cursor-pointer hover:scale-110 hover:shadow-lg transition-all duration-200"
              >
                2
              </button>
              <div className="w-16 h-1 bg-primary" />
              <div className="flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium bg-primary text-white dark:text-black">
                3
              </div>
            </div>
          </div>

          {/* Step Content */}
          <SuccessStep
            selectedChallenge={selectedChallenge}
            customTitle={customTitle}
            createdChallenge={createdChallenge}
            onComplete={handleComplete}
            onCreateAnother={handleCreateAnother}
          />
        </div>
      </div>
    </div>
  )
} 